import { Component, Input } from '@angular/core';

import {
  GridData,
  CellComponent,
  CellContext,
  NumericCellConfig,
} from '@grid/models';
import { Constants as GridConstants } from '@grid/utils/constants';
import { isNumericValue } from '@shared/utils';

// Not OnPush: the grid assigns `context` directly and recalculates derived values
// into the row in place, so an OnPush cell would keep showing the old value.
@Component({
  selector: 'app-decimal-display',
  // prettier-ignore
  template: `<span [attr.data-testId]="'display-' + context.column.header.name + '-' + context.row.index">
  <ng-container *ngIf="isNumeric; else rawValue">
    {{ value | number: format }}{{ config?.options?.allowPercentage ? '%' : '' }}
  </ng-container>
  <ng-template #rawValue>{{ nonNumericValue }}</ng-template>
  </span>`,
})
export class DecimalDisplayComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;

  readonly format = GridConstants.DefaultValues.decimalDisplayFormat;

  get config(): NumericCellConfig {
    return this.context.config as NumericCellConfig;
  }

  get value(): string | number {
    return this.context.data[this.context.column.columnDef];
  }

  // The number pipe throws on anything else, which would break the whole cell.
  get isNumeric(): boolean {
    return isNumericValue(this.value);
  }

  // A number the pipe can't format is NaN or Infinity, such as a percentage of a
  // target of 0, and shows blank.
  get nonNumericValue(): string | number {
    return typeof this.value === 'number' ? '' : this.value;
  }
}
